/*global VeloxViewController, VeloxWebView*/
 
var uuid = require("uuid") ;

var reportController = new VeloxViewController({
    directory : "views/diag",
    name: "report",
    route: "report"
}) ;

module.exports = reportController ;


reportController.prepareDataOnEnter = function(data, callback){
    if(!data){ data = {} ;}
    data.canPrint = window.native && window.native.pdf && window.native.pdf.genAndPrintReport;
    callback(null, data) ;
} ;

reportController.onReturn = function(){
    this.navigate("..") ;
} ;

reportController.updateDiag = function(diag, records){
    if(!diag.d_id){
        diag.d_id = uuid.v4() ;
    }
   
};

function getBase64Image(img) {
    var canvas = document.createElement("canvas");
    canvas.width = img.width;
    canvas.height = img.height;
    var ctx = canvas.getContext("2d");
    ctx.drawImage(img, 0, 0);
    var dataURL = canvas.toDataURL("image/png");
    return dataURL.replace(/^data:image\/(png|jpg);base64,/, "");
  }
  

reportController.getHtmlToPrint = function(local){
    var html = "<html>"+this.view.EL.reportFrame.contentWindow.document.documentElement.innerHTML+"</html>" ;

    html = html.replace(/templates\/html\/assets\//g, "") ;
    if(local){
        html = html.replace("/api/public/getDomainLogo", this.api.options.serverUrl+"api/public/getDomainLogo?domain="+this.api.currentDomain) ;
    }else{
        html = html.replace("/api/public/getDomainLogo", "http://localhost:3000/api/public/getDomainLogo?domain="+this.api.currentDomain) ;
    }
    
    return html;
} ;

reportController.onPdf = function(){
    this.view.longTask(function(done){ 
        var filename = VeloxWebView.tr("welcome.diag") ;
        if(this.data.diag.customer){
            filename += " - "+this.data.diag.customer.c_name ;
        }
        filename += ".pdf" ;
        if(window.native){
            //desktop native
            window.native.pdf.genAndOpenReport({html: this.getHtmlToPrint(true), filename:filename, lang: VeloxWebView.i18n.getLang()}, done) ;
        }else{
            this.api.pdf.gen(filename, this.getHtmlToPrint(), VeloxWebView.i18n.getLang(), done) ;
        }
    }.bind(this));
};
reportController.onPrint = function(){
    if(window.native){
        this.view.longTask(function(done){ 
            this.api.api.reseller_settings.searchFirst({}, function(err, settings){
                if(err){ return done(err) ;}

                window.native.pdf.genAndPrintReport({html: this.getHtmlToPrint(true), grayscale: settings?!settings.rs_print_color:false ,lang: VeloxWebView.i18n.getLang()}, done) ;
            }.bind(this));
        }.bind(this)) ;
    }
};


reportController.onBtClose = function(){
    this.navigate("/") ;
} ;

